export enum CheckoutMediaType {
  Video = 'VIDEO',
  Image = 'IMAGE',
}

export enum CheckoutService {
  ShutterStock = 'SHUTTERSTOCK',
  WixStock = 'WIXSTOCK',
}
